import { connect } from "react-redux";
import ShowAllInstancesScreen from "./ShowAllInstancesScreen";
import {
  removeStorehouseInstance,
  recountStorehouse,
} from "src/storehouse/redux/actions";

export default connect(
  (state) => {
    return {
      storehouse: state.storehouse.storehouse,
      profile: state.auth.profile,
    };
  },
  {
    removeStorehouseInstance,
    recountStorehouse,
  }
)(ShowAllInstancesScreen);
